import { useDictionary } from '@autobid/ui/composables/useDictionary'
import { computed, onServerPrefetch } from 'vue'
import { useNoFilterCounters } from '../car/data/useNoFilterCounters'

export function useFuelTypes(type: 'auction' | 'searchList') {
  const { data, suspense } = useNoFilterCounters(type)
  const { dictionary, suspense: suspenseDictionary } = useDictionary({ type: 'auctions' })

  onServerPrefetch(async () => {
    await Promise.all([
      suspense(),
      suspenseDictionary(),
    ])
  })

  const fuelType = computed(() => dictionary.value?.e17)

  const fuelTypesNoFilterCounters = computed(() => {
    const e17 = data.value?.counters?.e17 ?? {}

    return {
      e17,
      atLeastOneExists: Boolean(Object.values(e17).find(el => el)),
    }
  })

  const fuelTypesToDisplay = computed(() => {
    if (!fuelType.value?.options) {
      return []
    }

    return fuelType.value.options
      .filter(el => fuelTypesNoFilterCounters.value.e17[+el.id])
      .map((el) => {
        return {
          id: +el.id,
          label: el.label,
        }
      })
  })

  return { fuelTypesNoFilterCounters, fuelTypesToDisplay }
}
